module.exports = __webpack_public_path__ + "img/arrow-narrow-right.05553c92.svg";